import useTranslationHook from "hooks/useTranslationHook";
import styles from "../USPSection.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
//

const PriceMatchGuarantee = () => {
  const { t } = useTranslationHook();
  return (
    <>
      <div className={styles.upperSection}>
        <ul className={styles.list}>
          <li>
            {t("propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteeintro1")}
          </li>
          <li>
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteeintro2part1",
            )}
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteeintro2referafriend",
            )}
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteeintro2part2",
            )}
          </li>
        </ul>
      </div>

      <div className={styles.section}>
        <div>
          {t(
            "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteeconditionstitle",
          )}
        </div>
        <ul className={styles.list}>
          <li>
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteecondition1",
            )}
          </li>
          <li>
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteecondition2",
            )}
          </li>
          <li>
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteecondition3",
            )}
          </li>
          <li>
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteecondition4",
            )}
          </li>
          <li>
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteecondition5",
            )}
          </li>
        </ul>
      </div>

      <div className={styles.section}>
        <div>
          {t("propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteeclaimtitle")}
        </div>
        <ul className={styles.list}>
          <li>
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteeclaimstep1",
            )}
          </li>
          <li>
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteeclaimstep2",
            )}
          </li>
          <li>
            {t(
              "propertypage.propertyusp.lowestpriceguaranteesection.lowestpriceguaranteeclaimstep3",
            )}
          </li>
        </ul>
      </div>
    </>
  );
};

export default wrapperHOC(PriceMatchGuarantee, {
  componentName: "PriceMatchGuarantee-PropertyUSPs-PropertyPage",
  showForChina: true,
});
